
import { fetchCompanyAdminList } from 'commonRedux/getCompanyAdmin/dispatcher';
import { fetchFluidHandlerList } from 'commonRedux/getFluidHandler/dispatcher';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Spinner,
    Alert,
    Row,
    Col,
    FormFeedback
} from 'reactstrap';
import { updateCompanyById } from './redux/dispatcher';

function UpdateViewCompany({ args, isViewOnly, data, setIsUpdate, setIsViewOnly, searchQuery}) {
    
    const dispatch = useDispatch();
    const companyAdminListData = useSelector((state) => state.companyAdminReducer);
    const fluidHandlerListData = useSelector((state) => state.fluidHandlerReducer);

    const [companyName, setCompanyName] = useState(data?.company_name);
    const [companyAddress, setCompanyAddress] = useState(data?.address);
    const [companyContactPersonName, setCompanyContactPersonName] = useState(data?.contact_person_name);
    const [companyContactPersonNumber, setCompanyContactPersonNumber] = useState(data?.contact_number);
    const [companySubscriptionDate, setCompanySubscriptionDate] = useState(data?.contract_end_date);
    const [newEnterpriseCompany, setNewEnterpriseCompany] = useState(data?.is_parent_company);
    const [modal, setModal] = useState(true);
    const [status, setStatus] = useState(data?.status == 'active' ? true : false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [fluidHandlerList, setfluidHandlerList] = useState(fluidHandlerListData?.fluidHandlerList?.result || [])
   
    const [searchData, setSearchData] = useState('')
    const [filteredFluidHandlerList, setfilteredFluidHandlerList] = useState(fluidHandlerList);
    const [selectedFluidHandler, setSelectedFluidHandler] = useState(data?.fluid_handler || []);
    const [companyAdminList, setCompanyAdminList] = useState(companyAdminListData.companyAdminList?.result || []);
    const [companyAdmin, setCompanyAdmin] = useState(data?.company_admin)
    // const [companyAdmin, setCompanyAdmin] = useState('780090d6-862d-4811-b3da-e2d81b769c2c')


    const [waterCost, setWaterCost] = useState(data?.water_cost)
    const [formError, setFormError] = useState({
        companyName: false,
        address: false,
        contactPersonName: false,
        subscriptionDate: false,
        contactPersonNumber: false,
        waterCost: false, //optional
        selectedCompanyAdmin: false,
        selectedFluidHandlers: false
    })

    useEffect(()=>{
        setCompanyAdminList(companyAdminListData.companyAdminList?.result || [])
    },[companyAdminListData])

    useEffect(() => {
        const isParentComapny = data?.is_parent_company
        dispatch(fetchCompanyAdminList(isParentComapny === 1 ? true: false));
        dispatch(fetchFluidHandlerList());
    }, []);

    //Handle Model (Show or not)
    const toggleModal = () => {
        setModal(!modal);
        setError('');
        setLoading(false);
        setCompanyName('')
        setCompanyAddress('');
        setCompanyContactPersonName('')
        setCompanyContactPersonNumber('')
        setCompanySubscriptionDate('')
        setErrorMessage('');
        setIsUpdate(false);
        setIsViewOnly(false);
        setCompanyAdmin('')
        setSelectedFluidHandler([])
        setFormError({
            companyName: false,
            address: false,
            contactPersonName: false,
            subscriptionDate: false,
            contactPersonNumber: false,
            waterCost: false, //optional
            selectedCompanyAdmin: false,
            selectedFluidHandlers: false
        })
    };

    const handleStatusChange = () => setStatus(!status);

    const getTodayDate = () => {
        const today = new Date();
        // today.setDate(today.getDate() + 1); // Add one day to today's date
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    //Handle Form
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!companyName || !companyAddress || !companyContactPersonName || !companyContactPersonNumber || !companySubscriptionDate || !companyAdmin ) {
            setFormError({
                companyName: formError.companyName || !companyName,
                address: formError.address || !companyAddress,
                contactPersonName: formError.contactPersonName || !companyContactPersonName,
                subscriptionDate: formError.subscriptionDate || !companySubscriptionDate,
                contactPersonNumber: formError.contactPersonNumber || !companyContactPersonNumber,
                waterCost: formError.waterCost, //optional
                selectedCompanyAdmin: formError.selectedCompanyAdmin || !companyAdmin,
                selectedFluidHandlers: formError.selectedFluidHandlers 
            });
            setErrorMessage('Please correct the errors in the form.');
            return;
        }
        setErrorMessage('');
        setError('');
        try {
            const comapnyData = {
                "company_name":companyName, 
                "address":companyAddress, 
                "contact_person_name":companyContactPersonName, 
                "contact_number":companyContactPersonNumber, 
                "is_parent_company":newEnterpriseCompany, 
                "contract_end_date":companySubscriptionDate, 
                "status":status?'active':'inactive',
                "company_admin": companyAdmin,
                "fluid_handlers":selectedFluidHandler,
                "water_cost": waterCost,
            }

            dispatch(updateCompanyById(data?.id, comapnyData, toggleModal, searchQuery))

        } catch (err) {
            setError('Error adding company admin. Please try again.');
        } finally {
            // toggleModal();
        }
    };

    const handleFluidHandlerSelection = (e) => {
        const value = e.target.value;
        setSelectedFluidHandler(prevState =>
            prevState.includes(value)
                ? prevState.filter(item => item !== value)
                : [...prevState, value]
        );
    }

    const handleFluidHandlerSearch = (e) => {
        const value = e.target.value;
        setSearchData(value);

        const filteredData = fluidHandlerList.filter(item =>
            item?.first_name.toLowerCase().includes(value.toLowerCase())
        );
        setfilteredFluidHandlerList(filteredData);
    }

    //Regex
    const validatePersonName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, contactPersonName: false }));
            return;
        }
        const regex = /^.{2,100}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, contactPersonName: !isValid }));
    };

    const validateComapnyName = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, companyName: false }));
            return;
        }
        const regex = /^.{2,100}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, companyName: !isValid }));
    };

    const validateAddress = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, address: false }));
            return;
        }
        const regex = /^.{2,100}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, address: !isValid }));
    };

    const validatePersonNumber = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, contactPersonNumber: false }));
            return;
        }
        const regex = /^[0-9]{10}$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, contactPersonNumber: !isValid }));
    };

    const validateWaterCost = (e) => {
        const value = e.target.value;
        if (!value) {
            setError(false);
            setFormError(prevState => ({ ...prevState, waterCost: false }));
            return;
        }
        const regex = /^\d{1,10}(\.\d{1,})?$/;
        const isValid = regex.test(value);

        setError(!isValid);
        setFormError(prevState => ({ ...prevState, waterCost: !isValid }));
    };

    return (
        <div>
            {/* <Button color="primary" onClick={toggleModal}>
            Add Company
            </Button> */}

            <Modal isOpen={modal} toggle={toggleModal} {...args} modalClassName="custom-modal">
                <h1 style={{ textAlign: 'center', borderBottom: '4px solid #135674', color: '#135674' }} className=" m-3">
                    {
                        isViewOnly ? 'View Company' : 'Update Company'
                    }
                </h1>
                <ModalBody>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="companyName">Company Name<span style={{color:'red'}}>*</span></Label>
                                    <Input
                                        id="companyName"
                                        name="companyName"
                                        placeholder="Enter Company Name"
                                        type="text"
                                        value={companyName}
                                        invalid={formError.companyName}
                                        onChange={(e) => {
                                            setCompanyName(e.target.value)
                                            validateComapnyName(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={50}
                                    />
                                    <FormFeedback>Company Name must only contain alphabets.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="address">Address<span style={{color:'red'}}>*</span></Label>
                                    <Input
                                        id="address"
                                        name="address"
                                        placeholder="Enter Company Address"
                                        type="text"
                                        value={companyAddress}
                                        invalid={formError.address}
                                        onChange={(e) => {
                                            setCompanyAddress(e.target.value)
                                            validateAddress(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={100}
                                    />
                                    <FormFeedback>Address must contain only letters and numbers.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="contactPersonName">Contact Person Name<span style={{color:'red'}}>*</span></Label>
                                    <Input
                                        id="contactPersonName"
                                        name="contactPersonName"
                                        placeholder="Enter Company Contact Person Name"
                                        type="text"
                                        value={companyContactPersonName}
                                        invalid={formError.contactPersonName}
                                        onChange={(e) => {
                                            setCompanyContactPersonName(e.target.value)
                                            validatePersonName(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={25}
                                    />
                                    <FormFeedback>Person Name must only contain alphabets.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="subscriptionData">Subscription Valid Upto<span style={{color:'red'}}>*</span></Label>
                                    <Input
                                        id="subscriptionData"
                                        name="subscriptionData"
                                        type="date"
                                        value={companySubscriptionDate}
                                        min={getTodayDate()}
                                        onChange={(e)=>{ setCompanySubscriptionDate(e.target.value)
                                            setFormError(prevState => ({ ...prevState, subscriptionDate: false }))
                                        }}
                                        invalid={formError.subscriptionDate}
                                        disabled={isViewOnly}
                                    />
                                    <FormFeedback>Pelase select subscription date.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="contactPersonNumber">Contact Person Number<span style={{color:'red'}}>*</span></Label>
                                    <Input
                                        id="contactPersonNumber"
                                        name="contactPersonNumber"
                                        placeholder="Enter Company Contact Person Number"
                                        type="text"
                                        value={companyContactPersonNumber}
                                        invalid={formError.contactPersonNumber}
                                        onChange={(e) => {
                                            setCompanyContactPersonNumber(e.target.value)
                                            validatePersonNumber(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={10}
                                    />
                                    <FormFeedback>Person Number must be exactly 10 digits and contain only numbers.</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="watercost">Water Cost</Label>
                                    <Input
                                        id="watercost"
                                        name="watercost"
                                        placeholder="Enter Water Cost"
                                        type="text"
                                        value={waterCost}
                                        invalid={formError.waterCost}
                                        onChange={(e) => {
                                            setWaterCost(e.target.value)
                                            validateWaterCost(e)
                                        }}
                                        disabled={isViewOnly}
                                        maxLength={10}
                                    />
                                    <FormFeedback>Water Cost must be a number or a decimal.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="selectuser">Select {newEnterpriseCompany ? 'Enterprise':'Company'} Admin<span style={{color:'red'}}>*</span></Label>
                                    <Input
                                        type="select"
                                        name="selectuser"
                                        id="selectuser"
                                        // value={!isSuperAdmin ? 'fluidhandler' : roleType}
                                        // disabled={!isSuperAdmin}
                                        invalid={formError.selectedCompanyAdmin}
                                        value={companyAdmin}
                                        onChange={(e) => {
                                            setCompanyAdmin(e.target.value)
                                            setFormError(prevState => ({ ...prevState, selectedCompanyAdmin: false }))
                                        }}
                                        disabled={isViewOnly}
                                    >
                                        <option value={data?.adminId}>{data?.adminName}</option>
                                        {
                                            companyAdminList.map((item) => (
                                                <option value={item?.uuid} key={item?.uuid}>
                                                    {item?.first_name} {item?.last_name}
                                                </option>
                                            ))
                                        }
                                    </Input>
                                    <FormFeedback>Please select company admin.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label>Select Fluid Handlers</Label>
                                    <Input
                                        type="text"
                                        id="searchInput"
                                        value={searchData}
                                        onChange={handleFluidHandlerSearch}
                                        placeholder="Search Fluid Handler by their Name"
                                        invalid={formError.selectedFluidHandlers}
                                    />
                                    <div style={{ maxHeight: '125px', overflowY: 'auto', border: '1px solid #ced4da', padding: '10px' }} className='rounded '>

                                        {filteredFluidHandlerList.map((item) => (
                                            <CustomInput
                                                key={item?.uuid}
                                                type="checkbox"
                                                id={item?.uuid}
                                                label={`${item?.first_name} ${item?.last_name}`} 
                                                value={item?.uuid}
                                                
                                                checked={selectedFluidHandler.includes(item?.uuid)}
                                                onChange={(e) => {
                                                    handleFluidHandlerSelection(e)
                                                    setFormError(prevState => ({ ...prevState, selectedFluidHandlers: false }))
                                                }}
                                                className='m-1'
                                                disabled={isViewOnly || item?.iseditable}
                                            />
                                        ))}
                                    </div>
                                    <FormFeedback>Please select fluid handler.</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        <Row>
                            {/* <Col md={6}>
                                <FormGroup>
                                    <Label for="newEC">New Enterprise Company</Label>
                                    <CustomInput
                                        type="switch"
                                        id="newEC"
                                        name="newEC"
                                        label={newEnterpriseCompany ? 'Yes' : 'No'}
                                        checked={newEnterpriseCompany}
                                        onChange={(e) => setNewEnterpriseCompany(!newEnterpriseCompany)}
                                        disabled={isViewOnly}
                                    />
                                </FormGroup>
                            </Col> */}
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="statusSelect">Status</Label>
                                    <CustomInput
                                        type="switch"
                                        id="statusSelect"
                                        name="status"
                                        label={status ? 'Active' : 'Inactive'}
                                        checked={status}
                                        onChange={handleStatusChange}
                                        disabled={isViewOnly}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        
                    </Form>
                </ModalBody>
                <ModalFooter>
                    {
                        isViewOnly ? '' :

                            <Button color="primary" onClick={handleFormSubmit} disabled={loading}>
                                {loading ? <Spinner size="sm" /> : 'Update Company'}
                            </Button>
                    }
                    <Button color="secondary" onClick={toggleModal} style={isViewOnly ? {outline: 'none', boxShadow: 'none', backgroundColor:'#135674', color:'white'} : {}}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default UpdateViewCompany;

